import styled from 'styled-components';
import { media, fonts, mixins } from '../../../css';
import Base from '../Base/Base';

// eslint-disable-next-line
export const StyledHeadingThird = styled(Base)`
  font-family: ${fonts.fontBold};
  font-size: ${mixins.pxToRem(18)};
  line-height: ${mixins.pxToRem(26)};
  text-align: ${(props) => props.align};
  text-transform: ${(props) => props.textTransform};
  margin: ${(props) => (props.noMargins === false ? `0 0 ${mixins.pxToRem(15)} 0` : 0)};
  color: ${(props) => props.color};

  a {
    text-decoration: none;
    color: inherit;
    &:hover {
      text-decoration: underline;
    }
  }
  ${media.greaterThan('lg')`
    font-size: ${mixins.pxToRem(28)};
    line-height: ${mixins.pxToRem(38)};
    letter-spacing: 1px;
    margin: ${(props) => (props.noMargins === false ? `0 0 ${mixins.pxToRem(36)} 0` : 0)};
  `};
`;
